import { APP_URL_MEDICAL, COLLECTIVESERVICE } from '../constants';
import HttpClient from '../services/HttpClient';
const headers = {'Content-Type': 'application/json'};

export const getCollectiveService = (paginador, filters) => {
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_MEDICAL}${COLLECTIVESERVICE}criteria/?page=${paginador?.page}&size=${paginador?.size}&order=${paginador?.order}&columnOrder=${paginador?.columnOrder}`, filters, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const downloadCollectiveService = (idServicio) => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_MEDICAL}${COLLECTIVESERVICE}download-report/${idServicio}`, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const saveCollectiveService = (body) => {
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_MEDICAL}${COLLECTIVESERVICE}`, body, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}